import type { FC } from 'react'
import CssBaseline from '@mui/material/CssBaseline'

import Notifications from '~/shared/notifications/Notifications'
import { AppointmentModal } from '~/features/member-profile/clinical/appointments'

const Root: FC = () => (
  <>
    <CssBaseline />
    <Notifications />
    <AppointmentModal />
  </>
)

export default Root
